import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Checkbox,
  Space,
  Tabs,
  Radio,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
// import balanceGeneralPdf from "../../../../Pdf/balanceGeneralPdf";
import {
  SelectItem,
  Form,
  FormItem,
  cuentaMask,
  RangePickerItem,
  TableItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem,
  round2Decimals
} from "../../../../Components/Items";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import { ResponsiveLine } from "@nivo/line";
import moment from "moment";
import "moment/locale/es";
import reportesDePedidosPdf from "../../../../Pdf/reporteDePedidosPdf";
moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
const { TabPane } = Tabs;

class ReportePedidos extends Component {
  state = {
    loading: false,
    pdf: null,
    objetoClientes: null,
    todasClientes: null,
    objetoUsuarios: null,
    todasUsuarios: null,
    objetoProyectos: null,
    todasProyectos: null,
    objetoUniadesDeNegocio: null,
    todasUniadesDeNegocio: null,
    objetoCanalesVenta: null,
    dataReporte: null,
    todasPedidos: [],
    dataGrafico: [],
    campoGrafico: "subtotal",
    subtotal: 0,
    totalImpuestos: 0,
    total: 0,
    totalRetenciones: 0,
    totalACobrar: 0,
    desglosarProductos: false
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    const campoGraficoGuardado = localStorage.getItem(`graficoCampo_ReportePedidos_${this.props.empresaId}`);
    if (campoGraficoGuardado === "subtotal" || campoGraficoGuardado === "totalPagar") {
      this.setState({ campoGrafico: campoGraficoGuardado });
    }
    await axios
      .post(
        "clientes/selectClientes",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasClientes: res.data });
          this.setState({
            objetoClientes: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.stringBuscar}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "usuarios/selectUsuariosEmpresa",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasUsuarios: res.data });
          this.setState({
            objetoUsuarios: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre +
                    " " +
                    value.apellidoPaterno +
                    " " +
                    value.apellidoMaterno}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "unidadesdenegocio/selectUnidadesDeNegocio",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasUniadesDeNegocio: res.data });
          this.setState({
            objetoUniadesDeNegocio: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                  ) +
                    " - " +
                    value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "canalesVenta/selectCanalesVenta",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            objetoCanalesVenta: (res.data.canalesVenta || []).map((value) => (
              <Option value={value._id} key={value._id}>
                {value.codigo + " - " + value.nombre}
              </Option>
            )),
          });
        } else {
          message.error("Ha sucedido un error y no se cargaron los canales de venta");
        }
      });
    this.consultarReportePedidos({
      periodo: [moment().subtract(1, "month"), moment()],
      clientes: 0,
      vendedores: 0,
      canalesVenta: 0,
      filtrarProyecto: 0,
      estadoPedidos: 5,
    });
  }

  async crearGrafico(valuePedidos, fechaInicial, fechaFinal, campoGrafico = this.state.campoGrafico) {
    let grafico = [];
    let graficoSumatoria = [];
    let sumatoria = 0;

    let fechaCambiante = moment(fechaInicial).locale("es");
    const fechaFinalMoment = moment(fechaFinal).locale("es");

    if (fechaFinalMoment.diff(fechaCambiante, "days") <= 31) {
      while (fechaFinalMoment.diff(fechaCambiante, "days") !== -1) {
        // eslint-disable-next-line no-loop-func
        const pedidos = valuePedidos.filter((todosPedidos) => {
          if (isNaN(todosPedidos.fechaPedido)) {
            return moment(fechaCambiante).isSame(
              moment(todosPedidos.fechaPedido, "DD/MM/YYYY"),
              "date"
            );
          } else {
            return false;
          }
        });

        let totalPagar = 0;

        pedidos.map((valuePedidoDia) => {
          totalPagar += valuePedidoDia[campoGrafico] || 0;
          return null;
        });

        grafico.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar,
        });

        graficoSumatoria.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar + sumatoria,
        });

        sumatoria += totalPagar;
        fechaCambiante = moment(fechaCambiante).add(1, "day").locale("es");
      }
    } else if (fechaFinalMoment.diff(fechaCambiante, "days") < 180) {
      while (fechaFinalMoment.diff(fechaCambiante, "weeks") !== -1) {
        // eslint-disable-next-line no-loop-func
        const pedidos = valuePedidos.filter((todasPedidos) => {
          if (isNaN(todasPedidos.fechaPedido)) {
            return moment(fechaCambiante).isSame(
              moment(todasPedidos.fechaPedido, "DD/MM/YYYY"),
              "week"
            );
          } else {
            return false;
          }
        });
        let totalPagar = 0;

        pedidos.map((valuePedidoDia) => {
          totalPagar += valuePedidoDia[campoGrafico] || 0;
          return null;
        });

        grafico.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar,
        });

        graficoSumatoria.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar + sumatoria,
        });

        sumatoria += totalPagar;
        fechaCambiante = moment(fechaCambiante).add(1, "week").locale("es");
      }
    } else if (fechaFinalMoment.diff(fechaCambiante, "months") < 36) {
      while (fechaFinalMoment.diff(fechaCambiante, "months") !== -1) {
        // eslint-disable-next-line no-loop-func
        const pedidos = valuePedidos.filter((todasPedidos) => {
          if (isNaN(todasPedidos.fechaPedido)) {
            return moment(fechaCambiante).isSame(
              moment(todasPedidos.fechaPedido, "DD/MM/YYYY"),
              "month"
            );
          } else {
            return false;
          }
        });
        let totalPagar = 0;

        pedidos.map((valuePedidoDia) => {
          totalPagar += valuePedidoDia[campoGrafico] || 0;
          return null;
        });

        grafico.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar,
        });

        graficoSumatoria.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar + sumatoria,
        });

        sumatoria += totalPagar;
        fechaCambiante = moment(fechaCambiante).add(1, "month").locale("es");
      }
    } else {
      while (fechaFinalMoment.diff(fechaCambiante, "years") !== -1) {
        // eslint-disable-next-line no-loop-func
        const pedidos = valuePedidos.filter((todasPedidos) => {
          if (isNaN(todasPedidos.fechaPedido)) {
            return moment(fechaCambiante).isSame(
              moment(todasPedidos.fechaPedido, "DD/MM/YYYY"),
              "year"
            );
          } else {
            return false;
          }
        });
        let totalPagar = 0;

        pedidos.map((valuePedidoDia) => {
          totalPagar += valuePedidoDia[campoGrafico] || 0;
          return null;
        });

        grafico.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar,
        });

        graficoSumatoria.push({
          x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
          y: totalPagar + sumatoria,
        });

        sumatoria += totalPagar;
        fechaCambiante = moment(fechaCambiante).add(1, "year").locale("es");
      }
    }

    await this.setState({
      dataGrafico: [
        {
          id: "Pedidos",
          color: "hsl(15, 70%, 50%)",
          data: grafico,
        },
        {
          id: "Pedidos Acumulados",
          color: "hsl(15, 70%, 50%)",
          data: graficoSumatoria,
        },
      ],
    });
  }

  onChangeCampoGrafico = (campoGrafico) => {
    this.setState({ campoGrafico });
    localStorage.setItem(`graficoCampo_ReportePedidos_${this.props.empresaId}`, campoGrafico);
    if (this.state.dataReporte) {
      this.crearGrafico(
        this.state.todasPedidos,
        this.state.dataReporte.fechaInicial,
        this.state.dataReporte.fechaFinal,
        campoGrafico
      );
    }
  };

  consultarReportePedidos(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesDeVentas/reportePedidos",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.crearGrafico(
            res.data.pedidos,
            res.data.fechaInicial,
            res.data.fechaFinal
          );
          this.setState({
            loading: false,
            dataReporte: res.data,
            todasPedidos: res.data.pedidos,
            subtotal: res.data.subtotal,
            totalImpuestos: res.data.totalImpuestos,
            total: res.data.total,
            totalRetenciones: res.data.totalRetenciones,
            totalACobrar: res.data.totalACobrar,
            desglosarProductos: res.data.desglosarProductos,
          });
        } else if (res.data.success === 1) {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
        }
        this.setState({ loading: false });
      });
  }

  descargarExcel() {
    const parseFecha = (val) => {
      if (!val) return val;
      const m = moment(val, "DD/MM/YYYY", true);
      return m.isValid() ? new Date(Date.UTC(m.year(), m.month(), m.date(), 12, 0, 0)) : val;
    };
    const columnasFecha = ["Fecha", "Fecha Creacion"];
    let datosDescargar = []
    if (this.state.desglosarProductos) {
      for (const valuePedido of this.state.todasPedidos) {
        if (valuePedido.folio === '') {
          const pedido = this.state.todasPedidos.find(todasPedidos => todasPedidos.folio !== '' && todasPedidos._id.toString() === valuePedido._id.toString())
          datosDescargar.push({
            "Folio": pedido.folioPedido,
            "Serie": pedido.seriePedido,
            "Folio Venta": pedido.folioVenta,
            "Codigo Cliente": pedido.codigoCliente,
            "Clave Cliente": pedido.claveCliente,
            Fecha: parseFecha(pedido.fechaPedido),
            "Fecha Creacion": parseFecha(pedido.fechaCreacion),
            Cliente: pedido.cliente,
            "Razon social": pedido.razonSocial,
            "Codigo Insumo": valuePedido.codigoCliente,
            "Clave Insumo": valuePedido.claveCliente,
            "Cantidad": valuePedido.fechaPedido,
            "Descripcion": valuePedido.cliente,
            "Familia": valuePedido.familia,
            "Precio Unitario": valuePedido.total,
            "Descuento": valuePedido.descuento,
            "Subtotal Insumo": valuePedido.totalPagado,
            "Precio Con Impuestos": valuePedido.saldo,
            "Total Insumo": valuePedido.estado,
            SubTotal: pedido.subtotal,
            Impuestos: pedido.totalImpuestos,
            "Retenciones": pedido.totalRetenciones,
            Total: pedido.total,
            "Total A Cobrar": pedido.totalPagar,
            Moneda: pedido.moneda,
            Estado: pedido.estado,
            Vendedor: pedido.vendedor,
            "Canal de Venta": pedido.canalVenta,
            ...(this.props.equipoMedico && {
              Paciente: pedido.paciente,
              Doctor: pedido.doctor,
              "Cirugía": pedido.cirugia,
            }),
          })
        }
      }
    } else {
      datosDescargar = this.state.todasPedidos.map((valuePedido) => {
        // const fechaHoy = moment();
        // let diasVencidos = "";

        // if (valuePedido.fechaVencimiento) {
        //   const fechaVencimiento = moment(valuePedido.fechaVencimiento);
        //   if (fechaVencimiento.isValid()) {
        //     let diff = fechaHoy.diff(fechaVencimiento, "days");
        //     diasVencidos = diff > 0 ? diff : 0; // solo positivos
        //   } else {
        //     diasVencidos = ""; // si la fecha no es válida
        //   }
        // }
        let impuestosAgregar = {}
        if (Array.isArray(valuePedido.arrayImpuestos)) {
          valuePedido.arrayImpuestos.forEach(impuesto => {
            impuestosAgregar[impuesto.descripcionFactura] = round2Decimals(impuesto.totalImpuestos)
          });
        }
        return {
          "Folio": valuePedido.folioPedido,
          "Serie": valuePedido.seriePedido,
          "Folio Venta": valuePedido.folioVenta,
          "Codigo Cliente": valuePedido.codigoCliente,
          "Clave Cliente": valuePedido.claveCliente,
          Fecha: parseFecha(valuePedido.fechaPedido),
          "Fecha Creacion": parseFecha(valuePedido.fechaCreacion),
          Cliente: valuePedido.cliente,
          "Razon social": valuePedido.razonSocial,
          "Metodo de Pago": valuePedido.metodoPago,
          SubTotal: valuePedido.subtotal,
          Impuestos: valuePedido.totalImpuestos,
          "Retenciones": valuePedido.totalRetenciones,
          Total: valuePedido.total,
          "Total A Cobrar": valuePedido.totalPagar,
          Moneda: valuePedido.moneda,
          Estado: valuePedido.estado,
          Vendedor: valuePedido.vendedor,
          "Canal de Venta": valuePedido.canalVenta,
          ...(this.props.equipoMedico && {
            Paciente: valuePedido.paciente,
            Doctor: valuePedido.doctor,
            "Cirugía": valuePedido.cirugia,
          }),
          ...impuestosAgregar,
        };
      });
    }
    const worksheet = XLSX.utils.json_to_sheet(datosDescargar, { cellDates: true });
    if (worksheet["!ref"]) {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      const indicesFecha = [];
      for (let C = range.s.c; C <= range.e.c; C++) {
        const header = worksheet[XLSX.utils.encode_cell({ r: range.s.r, c: C })];
        if (header && columnasFecha.includes(header.v)) {
          indicesFecha.push(C);
        }
      }
      for (let R = range.s.r + 1; R <= range.e.r; R++) {
        for (const C of indicesFecha) {
          const cell = worksheet[XLSX.utils.encode_cell({ r: R, c: C })];
          if (cell && cell.v instanceof Date) {
            cell.t = "d";
            cell.z = "dd/mm/yyyy";
          }
        }
      }
    }
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte Pedidos");
    //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, `Reporte_De_Pedidos_${moment().locale("es").format("L")}.xlsx`);
  }

  descargarPdf() {
    pdfMake
      .createPdf(reportesDePedidosPdf(this.state.dataReporte))
      .download(`Reporte_De_Pedidos_${moment().locale("es").format("L")}`);
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }
  render() {
    const columns = [
      {
        title: "Folio",
        dataIndex: "folio",
        key: "folio",
        sorter: (a, b) => {
          if (a.folio < b.folio) {
            return -1;
          }
          if (a.folio > b.folio) {
            return 1;
          }
          return 0;
        },
        buscar: "folio",
        ellipsis: true,
      },
      {
        title: "Fecha",
        dataIndex: "fechaPedido",
        key: "fechaPedido",
        sorter: (a, b) => {
          if (moment(a.fechaPedido, "DD/MM/YYYY") < moment(b.fechaPedido, "DD/MM/YYYY")) {
            return -1;
          }
          if (moment(a.fechaPedido, "DD/MM/YYYY") > moment(b.fechaPedido, "DD/MM/YYYY")) {
            return 1;
          }
          return 0;
        },
        buscar: "fechaPedido",
        ellipsis: true,
      },
      {
        title: "Cliente",
        dataIndex: "cliente",
        key: "cliente",
        sorter: (a, b) => {
          if (a.cliente < b.cliente) {
            return -1;
          }
          if (a.cliente > b.cliente) {
            return 1;
          }
          return 0;
        },
        buscar: "cliente",
        ellipsis: true,
      },
      {
        title: "Vencimiento",
        dataIndex: "fechaVencimiento",
        key: "fechaVencimiento",
        sorter: (a, b) => {
          if (!a.fechaVencimiento && !b.fechaVencimiento) return 0;
          if (!a.fechaVencimiento) return 1;
          if (!b.fechaVencimiento) return -1;
          if (moment(a.fechaVencimiento, "DD/MM/YYYY") < moment(b.fechaVencimiento, "DD/MM/YYYY")) {
            return -1;
          }
          if (moment(a.fechaVencimiento, "DD/MM/YYYY") > moment(b.fechaVencimiento, "DD/MM/YYYY")) {
            return 1;
          }
          return 0;
        },
        buscar: "fechaVencimiento",
        ellipsis: true,
      },
      {
        title: "Total",
        dataIndex: "totalPagar",
        key: "totalPagar",
        sorter: (a, b) => {
          if (a.totalPagar < b.totalPagar) {
            return -1;
          }
          if (a.totalPagar > b.totalPagar) {
            return 1;
          }
          return 0;
        },
        buscar: "totalPagar",
        render: (value) => dineroDisabledMask(value),
        align: "right",
        ellipsis: true,
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        sorter: (a, b) => {
          if (a.estado < b.estado) {
            return -1;
          }
          if (a.estado > b.estado) {
            return 1;
          }
          return 0;
        },
        buscar: "estado",
        ellipsis: true,
      },
      {
        title: "Vendedor",
        dataIndex: "vendedor",
        key: "vendedor",
        sorter: (a, b) => {
          if (a.vendedor < b.vendedor) {
            return -1;
          }
          if (a.vendedor > b.vendedor) {
            return 1;
          }
          return 0;
        },
        buscar: "vendedor",
        ellipsis: true,
      },
      {
        title: "Canal de Venta",
        dataIndex: "canalVenta",
        key: "canalVenta",
        sorter: (a, b) => {
          if ((a.canalVenta || "") < (b.canalVenta || "")) return -1;
          if ((a.canalVenta || "") > (b.canalVenta || "")) return 1;
          return 0;
        },
        buscar: "canalVenta",
        ellipsis: true,
      },
      ...(this.props.equipoMedico
        ? [
            {
              title: "Paciente",
              dataIndex: "paciente",
              key: "paciente",
              sorter: (a, b) => {
                if ((a.paciente || "") < (b.paciente || "")) return -1;
                if ((a.paciente || "") > (b.paciente || "")) return 1;
                return 0;
              },
              buscar: "paciente",
              ellipsis: true,
            },
            {
              title: "Doctor",
              dataIndex: "doctor",
              key: "doctor",
              sorter: (a, b) => {
                if ((a.doctor || "") < (b.doctor || "")) return -1;
                if ((a.doctor || "") > (b.doctor || "")) return 1;
                return 0;
              },
              buscar: "doctor",
              ellipsis: true,
            },
            {
              title: "Cirugía",
              dataIndex: "cirugia",
              key: "cirugia",
              sorter: (a, b) => {
                if ((a.cirugia || "") < (b.cirugia || "")) return -1;
                if ((a.cirugia || "") > (b.cirugia || "")) return 1;
                return 0;
              },
              buscar: "cirugia",
              ellipsis: true,
            },
          ]
        : []),
    ];
    return (
      <>
        <Form
          ref={this.formRef}
          name="reportePedidos"
          onFinish={this.consultarReportePedidos.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            periodo: [moment().subtract(1, "month"), moment()],
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte Pedidos"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcel()}
                      icon={<FileExcelOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar Excel
                    </ButtonItem>
                  )}
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarPdf()}
                      icon={<FilePdfOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar PDF
                    </ButtonItem>
                  )}
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: (
                    <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                      Filtros:
                    </h1>
                  ),
                }}
              >
                <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                  <FormItem name="periodo" required noStyle>
                    <RangePickerItem />
                  </FormItem>
                </TabPane>
                <TabPane tabKey="2" key="2" forceRender tab="Clientes">
                  <FormItem name="clientes" noStyle margin>
                    <SelectItem
                      width="90%"
                      mode="multiple"
                      placeholder="Clientes"
                    >
                      {this.state.objetoClientes}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="3" key="3" forceRender tab="Vendedores">
                  <FormItem name="vendedores" margin noStyle>
                    <SelectItem
                      width="90%"
                      mode="multiple"
                      placeholder="Vendedores"
                    >
                      {this.state.objetoUsuarios}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Proyecto">
                  <Row>
                    <Col span={8}>
                      <FormItem
                        name="filtrarProyecto"
                        required
                        noStyle
                        initialValue={0}
                      >
                        <SelectItem width="90%" placeholder="Filtrar Proyecto">
                          <Option default value={0}>
                            Niguno
                          </Option>
                          <Option value={1}>Proyectos</Option>
                          <Option value={2}>Unidades de negocio</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const filtrarProyecto =
                            getFieldValue("filtrarProyecto");
                          if (filtrarProyecto === 1) {
                            return (
                              <FormItem required name="proyectos" margin noStyle>
                                <SelectItem
                                  width="90%"
                                  placeholder="Proyectos"
                                  mode="multiple"
                                >
                                  {this.state.objetoProyectos}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                          if (filtrarProyecto === 2) {
                            return (
                              <FormItem required margin name="unidadDeNegocioId" noStyle>
                                <SelectItem
                                  width="90%"
                                  placeholder="Unidades de Negocio"
                                >
                                  {this.state.objetoUniadesDeNegocio}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                        }}
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabKey="5" key="5" forceRender tab="Detalles">
                  <Row style={{ padding: 0, margin: 0 }} gutter={[16, 0]}>
                    <Col span={8}>
                      <FormItem
                        label="Estado"
                        name="estadoPedidos"
                        required
                        initialValue={5}
                        style={{ marginBottom: 0 }}
                      >
                        <SelectItem placeholder="Filtrar Por">
                          <Option default value={5}>
                            Todos
                          </Option>
                          <Option value={3}>Venta</Option>
                          <Option value={2}>Pendiente</Option>
                          <Option value={1}>Vigente</Option>
                          <Option value={0}>Cancelados</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem
                        label="Desglosar Productos"
                        name="desglosarProductos"
                        valuePropName="checked"
                        margin
                      >
                        <Checkbox />
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      {/* <FormItem
                        label="Detalle"
                        name="detalle"
                        valuePropName="checked"
                        margin
                      >
                        <Checkbox />
                      </FormItem> */}
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabKey="6" key="6" forceRender tab="Canales de Venta">
                  <FormItem name="canalesVenta" margin noStyle>
                    <SelectItem
                      width="90%"
                      mode="multiple"
                      placeholder="Canales de Venta"
                    >
                      {this.state.objetoCanalesVenta}
                    </SelectItem>
                  </FormItem>
                </TabPane>
              </Tabs>
            </div>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingBottom: 35,
                marginTop: 10,
                marginBottom: 10,
                height: 420,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 10 }}>
                <h1 style={{ fontSize: 18, margin: 0 }}>Gráfico</h1>
                <Radio.Group
                  size="small"
                  value={this.state.campoGrafico}
                  onChange={(e) => this.onChangeCampoGrafico(e.target.value)}
                >
                  <Radio.Button value="subtotal">Subtotal</Radio.Button>
                  <Radio.Button value="totalPagar">Total a Pagar</Radio.Button>
                </Radio.Group>
              </div>

              <ResponsiveLine
                data={this.state.dataGrafico}
                margin={{ top: 15, right: 20, bottom: 70, left: 100 }}

                // ✅ Tooltips tipo “línea vertical” (mucho más claro)
                enableSlices="x"
                useMesh={true}

                yFormat={(e) => dineroDisabledMask(Math.abs(e))}

                xScale={{ type: "point" }}
                yScale={{
                  type: "linear",
                  min: 0,
                  max: "auto",
                  stacked: false,
                  reverse: false,
                }}

                curve="monotoneX"
                lineWidth={2}

                // ✅ Menos ruido visual
                pointSize={5}
                pointBorderWidth={1}
                pointColor={{ theme: "background" }}
                pointBorderColor={{ from: "serieColor" }}

                // Si quieres aún más limpio, descomenta:
                // enablePoints={false}

                colors={["#8B5CF6", "#F97316"]}
                colorBy="index"

                axisTop={null}
                axisRight={null}

                axisBottom={{
                  tickSize: 5,
                  tickPadding: 8,
                  tickRotation: 45,
                  // ✅ muestra menos etiquetas (una de cada 2 o 3)
                  tickValues: (this.state.dataGrafico?.[0]?.data || [])
                    .map(d => d.x)
                    .filter((_, i) => i % 2 === 0),
                }}

                axisLeft={{
                  tickSize: 5,
                  tickPadding: 8,
                  format: (v) => dineroDisabledMask(Math.abs(v)),
                }}

                // ✅ Grid más limpio
                enableGridX={false}

                legends={[
                  {
                    anchor: "top-right",
                    direction: "column",
                    translateX: 0,
                    translateY: 0,
                    itemWidth: 130,
                    itemHeight: 18,
                    symbolSize: 10,
                    symbolShape: "circle",
                    itemOpacity: 0.85,
                    effects: [
                      {
                        on: "hover",
                        style: {
                          itemOpacity: 1,
                        },
                      },
                    ],
                  },
                ]}
              />
            </div>
            <div
              style={{
                backgroundColor: "white",
                padding: 15,
                marginBottom: 10,
                height: "75px",
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Row>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Subtotal</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.subtotal)}
                  </h1>
                </Col>
                <Col span={1} style={{ textAlign: "center" }}>
                  <h1 style={{ fontSize: 20 }}>+</h1>
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Impuestos</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.totalImpuestos)}
                  </h1>
                </Col>
                <Col span={1} style={{ textAlign: "center" }}>
                  <h1 style={{ fontSize: 20 }}>=</h1>
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Total</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.total)}
                  </h1>
                </Col>
                <Col span={1} style={{ textAlign: "center" }}>
                  <h1 style={{ fontSize: 20 }}>-</h1>
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Retenciones</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.totalRetenciones)}
                  </h1>
                </Col>
                <Col span={1} style={{ textAlign: "center" }}>
                  <h1 style={{ fontSize: 20 }}>=</h1>
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Total Cobrar</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.totalACobrar)}
                  </h1>
                </Col>
              </Row>
            </div>
            <TableItem
              onRow={(record, rowIndex) => {
                return {
                  onDoubleClick: (event) => {
                    this.props.history.push("/panel/verPedido", {
                      id: record._id,
                    });
                  },
                };
              }}
              rowKey={(value) => value._id.toString() + Math.random()}
              columns={columns}
              dataSource={this.state.todasPedidos}
              size="small"
              pagination={false}
            />
            {/* <div style={{ backgroundColor: "white", padding: 20, paddingTop: 5 }}>
          {this.state.pdf && (
            <iframe
              title={"documentos"}
              style={{ width: "100%", height: "100vh" }}
              id="printPdf"
              name="printPdf"
            />
          )}
        </div> */}
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    equipoMedico: state.empresa.equipoMedico,
  };
};

export default connect(mapStateToProps)(ReportePedidos);